// Tone-preference persistence. Update logic is pure (utils/tone-preference);
// this module just reads/writes tonePreferences/{userId}.
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { COLLECTIONS } from '../constants/collections';
import {
  updateTonePreference, setManualTone, defaultTonePreference,
  type TonePreference, type ToneReaction, type ToneRegister,
} from '../utils/tone-preference';

export async function loadTonePreference(userId: string): Promise<TonePreference | null> {
  const snap = await getDoc(doc(db, COLLECTIONS.TONE_PREFERENCES, userId));
  return snap.exists() ? (snap.data() as TonePreference) : null;
}

/** Record a humor reaction and persist the nudged preference. Returns the new state. */
export async function recordToneReaction(userId: string, reaction: ToneReaction): Promise<TonePreference> {
  const ref = doc(db, COLLECTIONS.TONE_PREFERENCES, userId);
  const snap = await getDoc(ref);
  const prev = snap.exists() ? (snap.data() as TonePreference) : null;
  const next = updateTonePreference(prev, reaction, new Date());
  await setDoc(ref, { userId, ...next }, { merge: true });
  return next;
}

/** Manual override from the "Your Cogni vibe" control — pins the register. */
export async function setToneOverride(userId: string, register: ToneRegister): Promise<TonePreference> {
  const next = setManualTone(register, new Date());
  await setDoc(doc(db, COLLECTIONS.TONE_PREFERENCES, userId), { userId, ...next }, { merge: true });
  return next;
}

/** Reset back to the safe dry-wit default (low confidence — starts learning afresh). */
export async function resetTonePreference(userId: string): Promise<TonePreference> {
  const next = defaultTonePreference(new Date());
  await setDoc(doc(db, COLLECTIONS.TONE_PREFERENCES, userId), { userId, ...next }, { merge: true });
  return next;
}
